import { createExternalStore } from "@nova/toolkit-pure-hooks"

type AircraftPoint = { id: string; lat: number; lng: number }

const adsbPositions = createExternalStore<AircraftPoint>()
const spidertracksPositions = createExternalStore<AircraftPoint>()

export const getAircraftLivePosition = (id: string) =>
    adsbPositions.getItem(id) ?? spidertracksPositions.getItem(id)

export const setAdsbLivePositions = (aircraft: AircraftPoint[]) =>
    adsbPositions.replaceAll(aircraft, (a) => a.id)

export const setSpidertracksLivePositions = (aircraft: AircraftPoint[]) =>
    spidertracksPositions.replaceAll(aircraft, (a) => a.id)
